import { combineReducers } from "redux";
import aktifitas_unduh from "./aktifitasUnduh";
import auth from "./auth";
import bpkhtl from "./bpkhtl";
import bpkhtl_province from "./bpkhtl-province";
import bpkhtl_user from "./bpkhtl-user";
import cakupanWilayah from "./cakupanWilayah";
import data_bpkhtl from "./dataBPKHTL";
import data_internal from "./dataInternal";
import data_eksternal from "./dataEksternal";
import data_produsen from "./dataProdusen";
import data_perbaikan_produsen from "./dataPerbaikanProdusen";
import data_pemeriksaan from "./dataPemeriksaan";
import data_publikasi from "./dataPublikasi";
import message from "./message";
import eksternal from "./eksternal";
import eksternalTematik from "./eksternal-tematik";
import eksternal_province from "./eksternal-province";
import eksternal_region from "./eksternal-region";
import eksternal_user from "./eksternal-user";
import igtInternal from "./igt-internal";
import igtEksternal from "./igt-eksternal";
import internal from "./internal";
import internalTematik from "./internal-tematik";
import internal_province from "./internal-province";
import internal_region from "./internal-region";
import internal_user from "./internal-user";
import kategoriTematik from "./kategoriTematik";
import kategoriEksternal from "./kategoriEksternal";
import kategoriInternal from "./kategoriInternal";
import mekanismeEksternal from "./mekanismeEksternal";
import notifikasi from "./notifikasi";
import provinsi from "./provinsi";
import produsen from "./produsen";
import produsen_user from "./produsen-user";
import region from "./region";
import role from "./role";
import statusPemeriksaan from "./statusPemeriksaan";
import setting from "./setting";
import tematik from "./tematik";
import user from "./user";

export default combineReducers({
  aktifitas_unduh,
  auth,
  bpkhtl,
  bpkhtl_province,
  bpkhtl_user,
  cakupanWilayah,
  data_bpkhtl,
  data_internal,
  data_eksternal,
  data_produsen,
  data_perbaikan_produsen,
  data_pemeriksaan,
  data_publikasi,
  eksternal,
  eksternalTematik,
  eksternal_province,
  eksternal_region,
  eksternal_user,
  internal,
  internalTematik,
  internal_province,
  internal_region,
  internal_user,
  igtEksternal,
  igtInternal,
  message,
  kategoriTematik,
  kategoriEksternal,
  kategoriInternal,
  mekanismeEksternal,
  notifikasi,
  provinsi,
  produsen,
  produsen_user,
  region,
  role,
  setting,
  statusPemeriksaan,
  tematik,
  user,
});
